import { render } from "./app-form-calendar.vue?vue&type=template&id=31006100"
import script from "./app-form-calendar.vue?vue&type=script&lang=js"
export * from "./app-form-calendar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__